import React, { FC, useMemo } from "react";
import { Station } from "@shared/models";
import { StatusLabel } from "@shared/components";
import { STATUS } from "@shared/constants";
import { getFirstLetters } from "@shared/utils";

interface SensorsPreviewProps {
  stations?: Station[];
}

const SensorsPreview: FC<SensorsPreviewProps> = ({ stations }) => {
  const sensors = useMemo(() => {
    if (!stations || !stations.length) return [];

    return stations.flatMap((st) => st.sensors);
  }, [stations]);

  if (!sensors.length) {
    return <>{"No Vital Signs Assigned"}</>;
  }

  return (
    <>
      {sensors.map((s) => (
        <StatusLabel
          key={s.id}
          circleStatus={s.is_active ? STATUS.ACTIVE : STATUS.INACTIVE}
          text={getFirstLetters(s.parameter) ?? "-"}
          textStatus={STATUS.INACTIVE}
          additionalText={s.sensor_code}
        />
      ))}
    </>
  );
};

export default SensorsPreview;
